export const EXCEL_PRODUCT_TAGS = [
  "24/7 Crisis Response",
  "3D Print Supplies",
  "3D Printers",
  "AED",
  "AI & Data Infrastructure",
  "AI Hardware",
  "Absorbent Mats",
  "Acoustical Panels",
  "Adaptors",
  "Advanced Optics",
  "Aerospace",
  "Age & ID Verification",
  "Air Purifiers",
  "Air Quality Monitors",
  "Air Treatment Systems",
  "Ammo",
  "Ammunition",
  "Amplifiers",
  "Antique Books",
  "Antenna",
  "Apparel",
  "Apparel - Custom",
  "Apparel - Gloves",
  "Apparel - Tactical",
  "Appliances",
  "Archery",
  "Audio Equipment",
  "Audio Supplies",
  "Audio/Vido Cables",
  "Auto Teller Machines",
  "Aviation Navigation",
  "Avionics",
  "Bags & Gear",
  "Ballasts",
  "Ballistics Meters",
  "Barrel Coolers",
  "Batteries",
  "Beehives",
  "Beehives Accessories",
  "Body Armor",
  "Books",
  "Boxes",
  "Breaching Tools",
  "Building Maintenance",
  "CCTV Accessories",
  "CCTV Cameras",
  "Cable",
  "Cable Extenders",
  "Cable Supplies",
  "Cables",
  "Camera",
  "Camera Mounts",
  "Camera Systems",
  "Cameras",
  "Canvas",
  "Carbon Fiber Tripods",
  "Carpet Tiles",
  "Cases & Storage",
  "Cash Recycler",
  "Ceiling Tiles",
  "Challenge Coins",
  "Chemlights",
  "Chest Rigs",
  "Cleaning Supplies",
  "Climbing Gear",
  "Commercial Dehumidifiers",
  "Commercial Printers",
  "Comms Gear",
  "Communications",
  "Complex Fabrics",
  "Computer Accessories",
  "Computer Components",
  "Computer Hardware",
  "Computers",
  "Construction Components",
  "Construction Safety",
  "Construction Tools",
  "Containment Equipment",
  "Coolers",
  "Custom",
  "Custom Computers",
  "Custom Medical Gear",
  "Cybersecurity",
  "Cybersecurity Hardware",
  "DIY Tools",
  "Data Loggers",
  "Defense Systems",
  "Digital Multimeters",
  "Digital Recorders",
  "Diving",
  "Drinkware",
  "Drone Accessories",
  "Drone Payloads",
  "Drones",
  "EMC Chambers",
  "EV Charging Stations",
  "EV Supplies",
  "Electrical",
  "Electrical Components",
  "Electrical Instruments",
  "Electrical Parts",
  "Electrician Gear",
  "Electroltic Rust Removal",
  "Electromagnetic Chronograph",
  "Electronic Components",
  "Electronic Tools",
  "Electronic Warfare",
  "Electronics",
  "Emergency Medical Supplies",
  "Emergency Supplies",
  "Everything",
  "Fabrics",
  "Faraday Bags",
  "Faraday Tents",
  "Fiber Optic",
  "Fiber Optics",
  "Financial Transactions",
  "Fire",
  "Firearms",
  "First Aid",
  "First Aid Kits",
  "Flashlights",
  "Fleet Supply",
  "Flooring",
  "Food",
  "Footwear",
  "Forensic Hardware",
  "Forensics",
  "Furniture",
  "Furniture - Classroom",
  "Furniture - Kitchen",
  "Furniture - Office",
  "GPS",
  "Gas Detection",
  "Gas Stations",
  "Generators",
  "Glass & Ceramic Materials",
  "Gun Accessories",
  "Gun Cases",
  "Gun Components",
  "Gun Parts",
  "Gun Range",
  "Gun Storage",
  "Gun Targets",
  "Guns",
  "Gunsmithing Tools",
  "HVAC",
  "HVAC Filters",
  "HVAC Parts",
  "Hair Accessories",
  "Hand Tools",
  "Handcuffs",
  "Hazmat Gear",
  "Heat Press Machines",
  "Heavy Duty Truck Parts",
  "Holsters",
  "Household Goods",
  "Hunting Gear",
  "Hunting Packs",
  "Hydraulic Cylinders",
  "Hydraulic Knockout Punches & Dies",
  "Hydropanel Systems",
  "IT Neworks",
  "IT Services",
  "Imaging Technology",
  "Industrial - Print",
  "Industrial Equipment",
  "Industrial Networking",
  "Industrial Parts",
  "Industrial Supplies",
  "Industrial Supply",
  "Industrial Water Chillers",
  "Infrastructure",
  "Ink & Toner",
  "Intrusion",
  "Inventory Management",
  "Jewelry",
  "Kevlar",
  "Kiosks",
  "Kitchen Equipment",
  "Knives",
  "Lab Supplies",
  "Laboratory Equipment",
  "Lamination",
  "Laptop",
  "Laptops",
  "Lasers",
  "Lighting",
  "Longarm Accessories",
  "Machinist Tools",
  "Magazines",
  "Magnetic Drill Press",
  "Mail",
  "Maintenance",
  "Marine",
  "Marine Electronics",
  "Marine Instruments",
  "Material Handling",
  "Medical",
  "Medical Equipment",
  "Medical Field",
  "Medical Gear",
  "Medical Supplies",
  "Metalworking Tools",
  "Micros SD",
  "Military Apparel",
  "Military Surplus",
  "Milling & Lathe",
  "Mini Excavators",
  "Missile Defense",
  "Motorola Radios",
  "Mounts",
  "Multimeters",
  "Network Cables",
  "Networking",
  "Networking Hardware",
  "Night Vision",
  "Night Vision Mounts",
  "Nightsticks",
  "Off Road Accessories",
  "Office Equipment",
  "Office Supplies",
  "Optical Tables",
  "Oscilloscopes",
  "Outdoor Cables",
  "Outdoor Gear",
  "PCB Fabrication",
  "POS System",
  "POS Systems",
  "Parts",
  "Patches",
  "Pet Accessories",
  "Pet Food",
  "Pet Medication",
  "Pharmaceuticals",
  "Phones",
  "Photography",
  "Pipeline Supplies",
  "Plaques",
  "Plumbing",
  "Portable Machining",
  "Portable Power",
  "Portable Ultrasound",
  "Posters",
  "Power Cords",
  "Power Protection",
  "Power Supplies",
  "Power Tools",
  "Power tools",
  "Precision Motion",
  "Print Media",
  "Print Supplies",
  "Printers",
  "Printing Accessories",
  "Printing Supplies",
  "Procurement",
  "R&D",
  "RF",
  "RF Engineering",
  "RF Supplies",
  "Radios",
  "Rasberry Pi",
  "Raw Material",
  "Raw Materials",
  "Respirators & Masks",
  "Restaurant Supplies",
  "Restraints",
  "Ribbons",
  "Rifle Mounts",
  "Robotics",
  "Routers",
  "Rugged Cases",
  "Rugged Mounts",
  "SCIF",
  "SD Cards",
  "Safety",
  "Safety Apparel",
  "Satellite Modems",
  "Scopes",
  "Scuba Gear",
  "Secure Comms",
  "Security",
  "Security Camera",
  "Security Cameras",
  "Self-Service Terminals",
  "Semiconductors",
  "Serface Vehicles",
  "Servers",
  "Blackout Comms",
  "Sewing",
  "Shields",
  "Shooting Accessories",
  "Shooting Apparel",
  "Shooting Range",
  "Shooting Supplies",
  "Shooting Targets",
  "Signs",
  "Smartwatches",
  "Snaplights",
  "Snow Gear",
  "Software - Cloud",
  "Software - Education",
  "Software - Healthcare",
  "Software - Networking",
  "Software - Security",
  "Solar",
  "Space Technology",
  "Spectrum Analyzers",
  "Sports & Fitness Tracker",
  "Spy Cameras",
  "Steel Targets",
  "Sunglasses",
  "Surgical Supplies",
  "Surveillance",
  "Surveillence",
  "Suspension Lift Kits",
  "Tablets",
  "Tactical",
  "Tactical Equipment",
  "Tactical Gear",
  "Tactical Helmets",
  "Tactical Plate Carriers",
  "Tactical Tools",
  "Target Accessories",
  "Target Stands",
  "Terrablock",
  "Thermal Cameras",
  "Thermal Imaging",
  "Thrusters & Actuators",
  "Tires",
  "Tobacco",
  "Toner",
  "Tools",
  "Tools - Electrician",
  "Tourniquets",
  "Toyota",
  "Trailer Parts",
  "Training - Medical",
  "Training - QCB",
  "Training - Sniper",
  "Training - Tactical",
  "Training Dummies",
  "Training Gear",
  "Trauma Kits",
  "Trave & Fishing",
  "Travel & Fishing",
  "Travel Security",
  "Tripods",
  "Truck Parts",
  "USB Flash Drives",
  "UTV Accessories",
  "UTV Parts",
  "UV Printers",
  "Ultrasonic Cleaners",
  "Ultrasound Accessories",
  "Undersea Systems",
  "Underwater Components",
  "Underwater ROVs",
  "Uniforms",
  "Vehicle",
  "Vehicle - Heavy Duty Truck",
  "Vehicle - Parts",
  "Vehicle Cleaning",
  "Vehicle GPS",
  "Vehicle Parts",
  "Vehicle Restoration Parts",
  "Vehicles",
  "WW2 Gear",
  "Wall Art",
  "Wall Murals",
  "Warehousing Supplies. Furniture - Warehouse",
  "Water",
  "Waterproof Cases",
  "Waterproof Paper & Writing",
  "Weather Stations",
  "Weather Tools",
  "Welding Equipment",
  "Wigs",
  "Wine",
  "Wire",
  "Wire Stripping",
  "Wireless Routers",
  "Woodworking",
  "Woodworking Gear",
  "Workout Apparel",
  "bladeRF",
  "eBikes"
];